import React from "react";
import ActionSheet from "./ActionSheet";
import ContactActions, { getContact } from "./ContactActions";

export function getRowTitle(row) {
  if (!row) return "";
  const join = (...v) => v.filter(Boolean).join(" ");
  return (
    row.Name ||
    join(row.FirstName, row.LastName) ||
    join(row.EmployeeFirstName, row.EmployeeLastName) ||
    row.StoreName ||
    row.Title ||
    row.TransactionNo ||
    ""
  );
}

// Phone row actions: the record's title and contact buttons (when it has a
// phone / email) above the list's row buttons
const RowActionSheet = ({ row, buttons, onAction, onClose }) => {
  const contact = getContact(row);
  return (
    <ActionSheet
      title={getRowTitle(row)}
      subtitle={[contact.phone, contact.email].filter(Boolean).join(" · ")}
      onClose={onClose}
      items={(buttons || []).map((button) => ({
        label: button.Text,
        icon: button.Icon || button.Type,
        danger: /delete|remove/i.test(button.Action || button.Type || button.Text || ""),
        onClick: () => onAction(button, row)
      }))}
    >
      <ContactActions record={row} />
    </ActionSheet>
  );
};

export default RowActionSheet;
